import { Home, Games, Analytics, History, About } from './pages';
import Credit from './pages/Portfolio';
import Referral from './pages/Referral';
import { BrowserRouter as Router, Navigate, Route, Routes } from 'react-router-dom';
import { createAppKit } from '@reown/appkit/react';
import { bsc } from '@reown/appkit/networks';
import { WagmiProvider } from 'wagmi';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { wagmiAdapter, projectId } from './config.jsx';
import toast, { ToastBar, Toaster } from 'react-hot-toast';
import { QueryParamProvider } from 'use-query-params';
import ScrollToTop from './components/ScrollToTop';
import RefLinkCapture from './components/RefLinkCapture';
import ErrorBoundary from './components/ErrorBoundary';

const queryClient = new QueryClient();

const metadata = {
  name: 'HashMedora',
  description: 'HashMedora - BSC Lottery Platform',
  url: 'https://hashmedora.com',
  icons: ['https://avatars.githubusercontent.com/u/37784886'],
};

createAppKit({
  adapters: [wagmiAdapter],
  networks: [bsc],
  projectId,
  metadata,
  features: {
    analytics: true,
    swaps: false,
    socials: false,
    email: false,
  },
  themeVariables: {
    '--w3m-accent': '#eed45b',
    '--w3m-font-family': 'Exo2',
    '--w3m-font-size-master': '10px',
  },
  customRpcUrls: {
    'eip155:56': [
      {
        url: 'https://bnb-mainnet.g.alchemy.com/v2/_R-gfMvFzGQV1fCIVr6aj',
      }
    ]
  }
});

function App() {
  return (
    <div className="App">
      <ErrorBoundary>
        <WagmiProvider reconnectOnMount config={wagmiAdapter.wagmiConfig}>
          <QueryClientProvider client={queryClient}>
            <QueryParamProvider>
              <Toaster position="top-right" reverseOrder={true} toastOptions={{ duration: 5000 }}>
                {(t) => (
                  <div style={{ cursor: 'pointer' }} onClick={() => toast.dismiss(t.id)}>
                    <ToastBar onClick={() => alert(1)} toast={t} />
                  </div>
                )}
              </Toaster>
              <Router>
                <RefLinkCapture />
                <ScrollToTop />
                <Routes>
                  <Route path="/ref" element={null} />
                  <Route path="/ref/*" element={null} />
                  <Route path="/" element={<Home />} />
                  <Route path="/games" element={<Games />} />
                  <Route path="/credit" element={<Credit />} />
                  <Route path="/affiliates" element={<Referral />} />
                  <Route path="/referral" element={<Navigate to="/affiliates" replace />} />
                  <Route path="/analytics" element={<Analytics />} />
                  <Route path="/history" element={<History />} />
                  <Route path="/about" element={<About />} />
                </Routes>
              </Router>
            </QueryParamProvider>
          </QueryClientProvider>
        </WagmiProvider>
      </ErrorBoundary>
    </div>
  );
}

export default App;
